import { popularRoutes, destinations, services, galleryImages } from './mock';

export const slugify = (s) => s.toLowerCase()
  .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
  .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const AI = 'https://static.prod-images.emergentagent.com/jobs/33b17408-d0b5-4936-a469-8100a5ab05c3/images/';
const serviceImg = {
  airport: AI + 'ba3cab54b32d5ff34dcb2fabb9f7b343fccb3e2c62e4c9494df45fc86309ab50.jpeg',
  tours: AI + '4e291871d9e169b071f6ee98d86d387cb1dff676f97aa37b15f1cc70a7d240db.jpeg',
  chauffeur: AI + '102349e4ffc48453bf1f02c17b4df5b70075155ac892bb5d9824ce460d05746a.jpeg',
  ski: AI + 'd3f0bea74c54839bf360ce41cde052ad982a716d5afe2cd6935311b94e358c84.jpeg',
  intercity: AI + '7f95f1641140fb253fd05e2d07b2c55710090e3ecb1c9d125e2714187459a2c3.jpeg',
  holiday: AI + '8741c4a56b833dcfe8f7f9f3266549feb52823d93c9fc9c2467286458b4081c3.jpeg',
};

const routeGuides = popularRoutes.map((r) => {
  const [from, to] = r.route.split(' to ');
  return { type: 'route', slug: slugify(r.route), title: r.route, img: r.img, from: from.trim(), to: (to || '').trim(), price: r.price };
});
const destGuides = destinations.map((d) => ({
  type: 'destination', slug: slugify(d.name), title: d.name, img: d.img, country: d.country, from: d.name, to: '',
}));
const serviceGuides = services.map((s) => ({
  type: 'service', slug: `service-${s.id}`, service: s, img: serviceImg[s.id] || serviceImg.airport, from: '', to: '',
}));
const galleryGuides = galleryImages.map((gi) => ({
  type: 'gallery', slug: slugify(gi.label), title: gi.label, img: gi.img, from: '', to: '',
}));

export const guides = [...routeGuides, ...destGuides, ...serviceGuides, ...galleryGuides];
export const guideBySlug = (slug) => guides.find((g) => g.slug === slug);

const perks = 'Professioneller Chauffeur, Flugverfolgung, Meet & Greet, kostenlose Wartezeit, Gratis-Wasser, WLAN und ein Kindersitz auf Wunsch – alles im Festpreis enthalten.';
const perksEn = 'Professional chauffeur, flight tracking, meet & greet, free waiting time, complimentary water, WiFi and a child seat on request – all in the fixed price.';
const why = 'Über 6000 zufriedene Reisende, 24/7 verfügbar, Festpreise ohne versteckte Kosten und kostenlose Stornierung bis 24 Stunden vor Fahrtbeginn.';
const whyEn = 'Over 6000 happy travellers, available 24/7, fixed prices with no hidden costs and free cancellation up to 24 hours before departure.';

const T = {
  de: {
    tag: 'Transfer-Guide', book: 'Jetzt buchen', bookRide: 'Diese Fahrt buchen', priceFrom: 'ab',
    routeIntro: (g) => `Ihr privater Flughafentransfer für die Strecke ${g.title} – zum Festpreis, ohne versteckte Kosten und mit professionellem Chauffeur.`,
    destIntro: (g) => `Zuverlässige Flughafentransfers und Chauffeurdienste von und zu ${g.title} in ${g.country}. Festpreise, pünktlich und komfortabel.`,
    routeSections: (g) => [
      { h: 'Über diese Strecke', p: `Mit CAB.TAXI reisen Sie entspannt auf der Strecke ${g.title}. Unser Chauffeur erwartet Sie pünktlich, verfolgt Ihren Flug automatisch und bringt Sie sicher und direkt an Ihr Ziel.` },
      { h: 'Immer inklusive', p: perks }, { h: 'Warum CAB.TAXI', p: why },
    ],
    destSections: (g) => [
      { h: `Transfers ab ${g.title}`, p: `Ob Ankunft oder Abflug – wir organisieren Ihren Transfer von und zu ${g.title} rund um die Uhr. Ihr Fahrer holt Sie direkt am Terminal ab.` },
      { h: 'Immer inklusive', p: perks }, { h: 'Warum CAB.TAXI', p: why },
    ],
    genSections: (desc) => [
      { h: 'Über diesen Service', p: desc }, { h: 'Immer inklusive', p: perks }, { h: 'Warum CAB.TAXI', p: why },
    ],
    galleryIntro: (title) => `Erleben Sie ${title} mit CAB.TAXI – zuverlässig, komfortabel und immer zum Festpreis.`,
    galleryDesc: (title) => `Unser Service für ${title}: ein professioneller Chauffeur, ein makelloses Fahrzeug und ein persönlicher Empfang. Wir kümmern uns um jedes Detail, damit Sie entspannt reisen.`,
    more: 'Mehr entdecken',
  },
  en: {
    tag: 'Transfer guide', book: 'Book now', bookRide: 'Book this ride', priceFrom: 'from',
    routeIntro: (g) => `Your private airport transfer for the ${g.title} route – at a fixed price, with no hidden costs and a professional chauffeur.`,
    destIntro: (g) => `Reliable airport transfers and chauffeur services to and from ${g.title} in ${g.country}. Fixed prices, punctual and comfortable.`,
    routeSections: (g) => [
      { h: 'About this route', p: `With CAB.TAXI you travel relaxed on the ${g.title} route. Your chauffeur waits on time, tracks your flight automatically and takes you safely and directly to your destination.` },
      { h: 'Always included', p: perksEn }, { h: 'Why CAB.TAXI', p: whyEn },
    ],
    destSections: (g) => [
      { h: `Transfers from ${g.title}`, p: `Whether arriving or departing, we arrange your transfer to and from ${g.title} around the clock. Your driver meets you at the terminal.` },
      { h: 'Always included', p: perksEn }, { h: 'Why CAB.TAXI', p: whyEn },
    ],
    genSections: (desc) => [
      { h: 'About this service', p: desc }, { h: 'Always included', p: perksEn }, { h: 'Why CAB.TAXI', p: whyEn },
    ],
    galleryIntro: (title) => `Experience ${title} with CAB.TAXI – reliable, comfortable and always at a fixed price.`,
    galleryDesc: (title) => `Our ${title} service: a professional chauffeur, an immaculate vehicle and a personal welcome. We take care of every detail so you can travel relaxed.`,
    more: 'Discover more',
  },
};

export const guideCopy = (g, lang) => {
  const c = T[lang] || T.en;
  if (g.type === 'route') return { tag: c.tag, title: g.title, intro: c.routeIntro(g), sections: c.routeSections(g), book: c.bookRide, priceFrom: c.priceFrom };
  if (g.type === 'destination') return { tag: c.tag, title: g.title, intro: c.destIntro(g), sections: c.destSections(g), book: c.book, priceFrom: c.priceFrom };
  if (g.type === 'service') {
    const loc = g.service[lang] || g.service.en;
    return { tag: c.tag, title: loc.title, intro: loc.desc, sections: c.genSections(loc.desc), book: c.book, priceFrom: c.priceFrom };
  }
  // gallery / generic
  return { tag: c.tag, title: g.title, intro: c.galleryIntro(g.title), sections: c.genSections(c.galleryDesc(g.title)), book: c.book, priceFrom: c.priceFrom, more: c.more };
};
